export default "__VITE_ASSET__1990457f__"